export const normalizeGuidTier = (guid: string): string => {
  const trimmed = guid.trim()
  if (!trimmed) {
    throw new Error('guid tier is required')
  }

  if (trimmed.startsWith('__')) return trimmed
  if (trimmed === 'free') return '__free'
  if (trimmed === 'graftcode') return '__graftcode'

  return `__${trimmed}`
}
